import { z } from 'zod';
import { BulkFindingsFilterSchema } from './findings.schemas';
import {
  FindingsGroupByFieldSchema,
  FindingsGroupCountSchema,
} from './findings-group-by.schema';

export const CountFindingsGroupsByFilterBodySchema =
  BulkFindingsFilterSchema.omit({ excludedIds: true }).extend({
    groupBy: FindingsGroupByFieldSchema,
    timeZone: z.string().min(1).max(64).optional(),
  });

export const CountFindingsGroupsByFilterResponseSchema = z.object({
  groups: z.array(FindingsGroupCountSchema),
});

export type CountFindingsGroupsByFilterBody = z.infer<
  typeof CountFindingsGroupsByFilterBodySchema
>;
export type CountFindingsGroupsByFilterResponse = z.infer<
  typeof CountFindingsGroupsByFilterResponseSchema
>;
